import { Contact } from '../domain/contact'

/*
 * Util class with various methods to validate user input
 */

/**
 * Check if the zipcode is valid
 * @param zipcode
 */
export const isValidZipcode = (zipcode: string) => {
    if (zipcode === null) return false;
    let regex = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i;
    return regex.test(zipcode);
};

/**
 * Check if the phonenumber is valid
 * @param phoneNumber
 */
export const isValidPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber === null) return false;
    let vast_nummer = /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/;
    let mobiel_nummer = /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7})$/i;
    return (vast_nummer.test(phoneNumber) || mobiel_nummer.test(phoneNumber) || phoneNumber === '112');
};

/**
 * Check if the user can add a new contact, this is allowed when:
 * 1. it is the first contact
 * 2. the last added contact is valid
 * @param contacts
 */
export const lastContactIsValid = (contacts: Contact[]) => {
    if (contacts.length === 0) return true;
    let lastContact = contacts[contacts.length -1];
    return (lastContact.contactName.length > 0 && isValidPhoneNumber(lastContact.phoneNumber));
};
